import { StyleSheet, Pressable, View } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";

interface ActivityCardProps {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  selectedId: number;
  isDisabled: boolean;
  handleCardPress: (id: number) => void;
  width: string;
}

const ActivityCard = ({
  id,
  title,
  description,
  icon,
  selectedId,
  isDisabled,
  handleCardPress,
  width,
}: ActivityCardProps) => {
  console.log("id: ", id);
  return (
    <Pressable
      testID={`activity-card-${id}`}
      key={id}
      style={[
        styles.card,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        { width } as any, // calc() works for web browser
        selectedId === id && styles.selectedCard,
        isDisabled && styles.disabledCard,
      ]}
      onPress={() => handleCardPress(id)}
      disabled={isDisabled}>
      <View>{icon}</View>
      <CustomText style={styles.title} size="l" weight="ultraBold" text={title} />
      <CustomText style={styles.description} size="s" weight="normal" text={description} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  selectedCard: {
    borderWidth: 4,
    borderColor: "#D0D5DD",
    padding: 17,
  },
  disabledCard: {
    opacity: 0.5,
    backgroundColor: "#F6F6F6",
  },
  title: {
    color: "#101828",
  },
  description: {
    color: "#667085",
  },
  card: {
    padding: 20,
    borderRadius: 24,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: 9,
    borderWidth: 1,
    borderColor: "#EAECF0",
    // @ts-expect-error - boxSizing works for web browser
    boxSizing: "border-box", // boxSizing works for web browser
    minHeight: 264,
  },
});

export default ActivityCard;
